import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ArticlesSearchService } from "../../../services/Articles/ArticlesSearch/ArticlesSearchService";
import { ArticleSearchModel } from "../../../models/Articles/ArticleSearch/ArticleSearchModel";

interface ContextProps {
    articles: ArticleSearchModel[],
    isLoading: boolean,
    setIsLoading: Dispatch<SetStateAction<boolean>>,
    error: string,
    setError: Dispatch<SetStateAction<string>>,
    handleSearch: (query: string) => Promise<boolean>,
}

export const ArticleSearchContext = createContext<ContextProps>({} as ContextProps);

interface ArticleSearchProviderProps {
    children: ReactNode;
}

export const ArticleSearchProvider = ({ children }: ArticleSearchProviderProps) => {
    const [articles, setArticles] = useState<ArticleSearchModel[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>('');

    const service = new ArticlesSearchService();

    const handleSearch = async (query: string) => {
        try {
            setIsLoading(true);
            const [_Response, _Error] = await service.search({ query });
            setIsLoading(false);

            if (!!_Error) {
                setError(_Response?.message || _Error);
                return false;
            }

            setError('');
            setArticles(_Response?.data);
            return true;
        } catch (e: any) {
            setIsLoading(false);
            setError(e.response?.data?.message || 'Houve um erro ao listar os artigos');
            return false;
        }
    }

    useEffect(() => {
        !!error && toast.error(error);
    }, [error]);

    return (
        <ArticleSearchContext.Provider value={{
            articles,
            isLoading,
            setIsLoading,
            error,
            setError,
            handleSearch
        }}>
            {children}
        </ArticleSearchContext.Provider>
    );
}

export const useArticleSearch = () => useContext(ArticleSearchContext);